export default __webpack_public_path__ + "static/media/Veskovic-pergola.36a7a82d.png";